import { useNavigate } from "react-router-dom";

import { Button } from "@/shared/ui/button";
import { Label } from "@/shared/ui/label";

export const SelectMentorButton = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Label className="text-sm font-normal md:text-[12px]">
        Связь с наставником
      </Label>
      <Button
        onClick={() => navigate("mentor-profiles")}
        variant="outline"
        className="w-full text-textColor"
      >
        Выбрать наставника
      </Button>
    </div>
  );
};
